import { ReactNode, useState } from 'react'
import { SearchOverlay } from './SearchOverlay'
import { SpotlightContext } from '../hooks/useSpotlight'

interface SpotlightProviderProps {
    children: ReactNode
}

export const SpotlightProvider: React.FC<SpotlightProviderProps> = ({ children }) => {
    const [opened, setOpened] = useState(false)

    const open = () => setOpened(true)
    const close = () => setOpened(false)

    return (
        <SpotlightContext.Provider value={{ opened, open, close }}>
            {children}
            {opened && <SearchOverlay opened={opened} onClose={close} />}
        </SpotlightContext.Provider>
    )
} 